import { render, staticRenderFns } from "./DialogTablePurchases.vue?vue&type=template&id=663ed199&scoped=true&"
import script from "./DialogTablePurchases.vue?vue&type=script&lang=js&"
export * from "./DialogTablePurchases.vue?vue&type=script&lang=js&"
import style0 from "./DialogTablePurchases.vue?vue&type=style&index=0&id=663ed199&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663ed199",
  null
  
)

export default component.exports